.error-count{color:#ff8989}
/*# sourceMappingURL=filing-mandatory-field-error-tooltip.component-4RHMXJBJ.css.map */
